import React from "react";
import '../../css/pager.less';
import classnames from 'classnames';
import { merge, pipe } from 'ramda';

/**
 * @param {Number} page Current page number
 * @param {Number} pageSize Page size
 * @param {Number} total Total items available
 * @param {Function} onPageClick Passed the required page number
 * @description Creates paging navigation with meta data about the total number of items displayed
 */
const Pager = ({ page, pageSize, total, onPageClick }) => {

    const firstIndex = ((page - 1) * pageSize) + 1;
    const lastIndex = firstIndex + (pageSize - 1);
    const lastindexCapped = Math.min(lastIndex, total);

    const lastPageNumber = Math.ceil(total / pageSize);

    const pagerClasses = classnames({
        'pager': true,
        'hidden': lastPageNumber < 2
    });

    const baseClasses = {
        "btn btn-sm": true,
    };

    const toPagerBtnClasses = (disabled) => {        
        return pipe(
            merge({
                "disabled": disabled,
                "btn-default": !disabled,
            }),
            classnames
        )(baseClasses);
    };

    const backwardClasses = toPagerBtnClasses(page === 1);

    const forwardClasses = toPagerBtnClasses(page === lastPageNumber);

    return (
        <ul className={pagerClasses}>
            <li className="pager-move pager-first" aria-label="First">
                <button className={backwardClasses} type="button" onClick={() => onPageClick(1)}>«</button>
            </li>
            <li className="pager-move" aria-label="Previous">
                <button className={backwardClasses} type="button" onClick={() => onPageClick(page - 1)}>‹</button>
            </li>

            <li className="pager-meta">{`${firstIndex} - ${lastindexCapped} of ${total}`}</li>

            <li className="pager-move" aria-label="Next">
                <button className={forwardClasses} type="button" onClick={() => onPageClick(page + 1)}>›</button>
            </li>
            <li className="pager-move pager-last" aria-label="Last">
                <button className={forwardClasses} type="button" onClick={() => onPageClick(lastPageNumber)}>»</button>
            </li>
        </ul>
    );
}

export default Pager;
